
  import {defineComponent, PropType} from "vue";
  import {Task} from "@/model/OrderTaskImport";
  import eventBus from "@/eventbus";
  import {MessageTypes} from "@/components/message-types";
  import {employeeUuid} from "@/store/StoreUtils";

  export default defineComponent({
    name: "OrdersListTile",
    props: {
      task: {
        type: Object as PropType<Task>,
        required: true,
        default: () => {
        },
      },
      isManager: {
        type: Boolean,
        default: false
      }
    },
    setup(props, context) {

      const onCheckbox = (task: Task) => {
        if (task) eventBus.$emit(MessageTypes.CHECK_TASK, task);
      };

      const openTaskDialog = (task: Task) => {
        context.emit("openTaskDialog", task);
      };

      const canCheckTask = (task: Task) => {
        return props.isManager ? true : task.employee.id == employeeUuid.value;
      };

      return {
        onCheckbox,
        openTaskDialog,
        canCheckTask
      };
    }
  });
